export const SAUDI_ARABIA_COUNTRY_CODE = "SA";
export const BAHRAIN_COUNTRY_CODE = "BH";
export const UNITED_ARAB_EMIRATES_COUNTRY_CODE = "AE";
